import dashboard from './dashboard';
import mobileAppConfigurations from './mobileAppConfigurations';

const menuItems = {
	items: [dashboard, mobileAppConfigurations],
};

export default menuItems;
